import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/core/services/login/login.service';
import { SetphonenumberService } from 'src/app/core/services/login/setphonenumber.service';
import { ServersideAlertService } from 'src/app/core/services/onboarding/serverside-alert.service';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { IVerifyPhoneNumber } from '../../../core/interfaces/login/verifyphonenumber.interface';

@Component({
  selector: 'app-verifyphonecode',
  templateUrl: './verifyphonecode.component.html',
  styleUrls: ['./verifyphonecode.component.scss'],
})
export class VerifyphonecodeComponent implements OnInit, OnDestroy {
  headerText = 'Verify Code';
  form: FormGroup;
  submitText = 'Verify';
  subscriptions: Subscription[] = [];

  constructor(
    private ls: LoginService,
    private ssas: ServersideAlertService,
    private router: Router,
    private sphs: SetphonenumberService,
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      verifyCodeText1: new FormControl(),
      verifyCodeText2: new FormControl(),
      verifyCodeText3: new FormControl(),
      verifyCodeText4: new FormControl(),
      verifyCodeText5: new FormControl(),
      verifyCodeText6: new FormControl(),
    });
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  async VerifyCode() {
    const payLoad = {
      code1: this.form.get('verifyCodeText1')?.value ?? '',
      code2: this.form.get('verifyCodeText2')?.value ?? '',
      code3: this.form.get('verifyCodeText3')?.value ?? '',
      code4: this.form.get('verifyCodeText4')?.value ?? '',
      code5: this.form.get('verifyCodeText5')?.value ?? '',
      code6: this.form.get('verifyCodeText6')?.value ?? '',
    };
    const combinedCode = `${payLoad.code1}${payLoad.code2}${payLoad.code3}${payLoad.code4}${payLoad.code5}${payLoad.code6}`;

    const model: IVerifyPhoneNumber = {
      Code: combinedCode,
      PhoneNumber: this.sphs.setPhoneNumber,
    };

    this.subscriptions.push(
      this.ls.verifyUserPhoneNumber(model).subscribe((res: any) => {
        if (res.Success === true) {
          this.redirectToRememberMe();
        } else {
          this.ssas.reportAlert([res.Message], 'error');
        }
      }),
    );
  }

  redirectToVerifyUser() {
    this.router.navigate(['/verifyuser']);
  }

  redirectToRememberMe() {
    this.router.navigate(['/remember-me']);
  }
}
